<img
  [id]="imageId"
  [class]="imageClass"
  *ngIf="imageSrc"
  [src]="imageSrc"
  [style]="imageStyle"
/>
